<div class="container-fluid">
  <app-header titleText="{{pageTitle}}" isAdmin="true">
    <div account>
      <img src="assets/img/circle_images/admin_circle.png" class="account-image" width="60" alt="My Account Icon" />
      <label class="text-bidit-account-header" i18n>My Account</label>
    </div>
    <div button>
      <a routerLink="/admin/account" class="btn btn-bidit-navigate btn-sm account-button" i18n>Edit Account</a>
      <select *ngIf="idiAdmin" class="form-control select-bidit"
              (change)="selectDealer()" [(ngModel)]="selectedDealer">
        <option [ngValue]="null">IDI</option>
        <option *ngFor="let dealer of dealers" [(ngValue)]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
      </select>
    </div>
  </app-header>
  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/clipboard-circle.png" alt="Lead Icon" class="card-icon" />
      <div class="bidit-card-title">
        <h3 class="text-bidit-account-header" i18n>Project Management</h3>
        <div i18n>Customize all aspects of BIDIT to your project management needs. Simply click on the tab to edit the appropriate area.</div>
      </div>
    </div>
    <div>
      <mat-tab-group class="project">
        <mat-tab label="Customers" i18n-label>
          <ng-template matTabContent>
            <div class="row">
              <div class=" col-md-12 col-lg-6">
                <app-admin-list listType="CustomerType"></app-admin-list>
              </div>
              <div class=" col-md-12 col-lg-6">
                <app-admin-list listType="ContactType"></app-admin-list>
              </div>

            </div>
            <div class="row pt-3">
                <div class="col-md-12 col-lg-6 ">
                    <app-admin-list listType="PaymentType"></app-admin-list>
                </div>
                <div class=" col-md-12 col-lg-6">
                    <app-admin-list listType="PaymentTerm"></app-admin-list>
                </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Leads" i18n-label>
            <ng-template matTabContent>
                <div class="row">
                    <div class="col-md-12 col-lg-6 ">
                        <app-admin-list listType="LeadSource"></app-admin-list>
                    </div>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab label="Quote Areas & Templates" i18n-label>
          <ng-template matTabContent>
            <div *ngIf="!showTemplate;then showLists else showTemplateEdit"></div>
            <ng-template #showLists>
                <div class="row bg-white ">
                    <div class="col-md-12 col-lg-6 ">
                        <app-area-list *ngIf="selectedDealer" listType="Area"></app-area-list>
                        <app-area-source-list *ngIf="!selectedDealer" listType="IDIAreaSource"></app-area-source-list>
                    </div>
                    <div class="col-md-12 col-lg-6 ">
                      <app-admin-list id="template_List" name="template_List" listType="QuoteTemplate" (showQuoteTemplate)="displayTemplateEdit($event)"></app-admin-list>
                      <app-admin-list id="itemNoteTemplate_List" name="itemNoteTemplate_List" listType="QuoteItemNoteTemplate" (showQuoteItemNoteTemplate)="displayItemNoteTemplateEdit($event)"></app-admin-list>
                    </div>
                </div>
            </ng-template>
            <ng-template #showTemplateEdit>
              <app-quote-template [id]="quoteTemplateId" (showList)="toggleTemplateDisplay($event)"></app-quote-template>
            </ng-template>
          </ng-template>
        </mat-tab>
        <mat-tab label="Quote Items" i18n-label>
            <ng-template matTabContent>
                <div class="col-md-12">
                    <app-item-list *ngIf="selectedDealer"></app-item-list>
                    <app-item-source-list *ngIf="!selectedDealer"></app-item-source-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                    <app-admin-list listType="ItemType"></app-admin-list>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="!quoteOnly" label="Jobs" i18n-label>
            <ng-template matTabContent>
                <div class="col-md-12 col-lg-6 ">
                    <app-admin-list listType="JobType"></app-admin-list>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="!quoteOnly" label="Work Orders" i18n-label>
          <ng-template matTabContent>
            <div class="row mx-1 my-3">
              <div class="form-inline col-12">
                <label class="col-form-label col-sm-2">
                  <span i18n>Set Default Times</span>
                </label>
                <label for="startTime" class="mr-2 col-form-label" i18n>Start</label>
                <select name="startTime" id="startTime" class="mr-5 form-control select-bidit"
                        [(ngModel)]="this.workOrderDefaultTimes.defaultStartTime" #startTime="ngModel">
                  <option [ngValue]="" selected="">-</option>
                  <option *ngFor="let time of this.times" [(ngValue)]="time">{{time}}</option>
                </select>

                <label for="stopTime" class="mr-2 col-form-label" i18n>End</label>
                <select name="stopTime" id="stopTime" class="mr-5 form-control select-bidit"
                        [(ngModel)]="this.workOrderDefaultTimes.defaultStopTime" #stopTime="ngModel">
                  <option [ngValue]="" selected="">-</option>
                  <option *ngFor="let time of this.times" [(ngValue)]="time">{{time}}</option>
                </select>
                <button type="button" class="btn btn-bidit-action mr-3" (click)="updatetDefaultWorkOrderDates()">Save</button>
                <div [hidden]="timeAlert == null"
                     class="alert alert-danger">
                  {{timeAlert}}
                </div>
              </div>
            </div>
            <div class="row bg-white ">
              <div class="col-md-12 col-lg-6 ">
                <app-admin-list listType="WorkOrderType"></app-admin-list>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

